<template lang="html">
  <div class="placed-backg contact-page-" id="page-info-t1">
    <!-- <div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.jpg)' }"></div> -->

    <section class="container oversized-container content-section">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-4 text-right col-info">
          <h5 class="text-right page-title">¿Quejas o sugerencias?</h5>
          <p>
            Nos gusta escuchar a nuestros clientes, ayudanos a mejorar, describenos tu problema o apoyanos con alguna sugerencia.
          </p>

          <br />
          <h5 class="text-right page-title">Horario de atención</h5>
          <p>
            Lunes a Viernes de 9:00 AM a 6:30 PM<br />
            Sábados de 9:00 AM a 2:00 PM
          </p>

          <br />
          <h5 class="text-right page-title">Domicilio</h5>
          <p>
            Av. Cruz del Sur 3237, Jardines del Sur,<br />
            C.P. 44950, Guadalajara, Jalisco, México.
          </p>

          <br />
          <h5 class="text-right page-title">Teléfonos</h5>
          <p>
            01 (33) 3646 0945<br />
            01 (33) 3587 7736<br />
            01 (33) 3367 4895
          </p>
        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                v-model="form.name"
                type="text"
                required
                placeholder="Nombre completo"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Correo electrónico"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.phone"
                type="text"
                required
                minlength="10"
                maxlength="10"
                placeholder="Teléfono"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.subject"
                type="text"
                required
                placeholder="Asunto"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-textarea
                v-model="form.msg"
                placeholder="Mensaje"
                required
                rows="5"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-send">Enviar mensaje</b-button>
            </p>
          </b-form>

        </div>
      </div>
    </section>

    <section class="container-fluid px-0 map-section">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.750966217036!2d-103.39472352413482!3d20.6390052010501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428adc7f50bb887%3A0x6227d9e3fcb8b7d!2sAv%20Cruz%20del%20Sur%203237%2C%20La%20Cruz%2C%2044950%20Guadalajara%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1724901862035!5m2!1ses-419!2smx" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        email: null,
        phone: null,
        subject: null,
        msg: null,
      },
      info: {
        contact:null,
      },
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-right',
        appendToast: true
      })
    },

    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/contact"), this.form).then((response)=>{
          this.makeToast('success', response.data.response, 'Mensaje enviado');
          this.form = {
            name: null,
            email: null,
            subject: null,
            msg: null,
            phone: null
          };
        }).catch( (error)=> {
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.subject, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
      });
    }
  },

  beforeMount(){
    // this.getInfo();

    if(this.$route.query.p){
      this.form.msg = 'Me intresa el producto '+ this.$route.query.p;
    }
  }
}
</script>
